import { render, staticRenderFns } from "./Inquiry.vue?vue&type=template&id=74b6d71d&scoped=true&"
import script from "./Inquiry.vue?vue&type=script&lang=js&"
export * from "./Inquiry.vue?vue&type=script&lang=js&"
import style0 from "./Inquiry.vue?vue&type=style&index=0&id=74b6d71d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b6d71d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VDatePicker,VMenu,VPagination,VSelect,VTextField})
